import * as types from '../constants/filters';

export const setFilter = (payload) => (dispatch) => {
  dispatch({
    type: types.SET_FILTER,
    payload
  });
};

export const resetFilter = () => (dispatch) => {
  dispatch({
    type: types.RESET_FILTER,
  });
};
